import { render, staticRenderFns } from "./warning-details.vue?vue&type=template&id=6df1350d"
import script from "./warning-details.ts?vue&type=script&lang=ts&external"
export * from "./warning-details.ts?vue&type=script&lang=ts&external"
import style0 from "./warning-details.less?vue&type=style&index=0&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6df1350d')) {
      api.createRecord('6df1350d', component.options)
    } else {
      api.reload('6df1350d', component.options)
    }
    module.hot.accept("./warning-details.vue?vue&type=template&id=6df1350d", function () {
      api.rerender('6df1350d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overview/warning-details/warning-details.vue"
export default component.exports